import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import Bubble from '@Shared/Bubble';
import Fader from '@Shared/Fader';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import useValidation from '../Hooks/useValidation';
import Email from '../Shared/Forms/Email';
import Phone from '../Shared/Forms/Phone';
import Text from '../Shared/Forms/Text';
import Captcha from './Captcha';
import GetStartedOrgs from './Orgs';
import GetStartedSubmit from './Submit';
import useSiteConfig from '@components/Hooks/useSiteConfig';

const GetStartedForm: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);

  const [org_id, setOrgId] = useState<number | null>(null);
  const [first_name, setFirstName] = useState<string>('');
  const [last_name, setLastName] = useState<string>('');
  const [phone_number, setPhoneNumber] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [captcha_response, setCaptchaResponse] = useState<string | null>(null);
  const { isNotEmpty, isPhoneNumber, isEmail } = useValidation();
  const site_config = useSiteConfig();

  const verifyCaptcha = (token: string | null): void => {
    setCaptchaResponse(token);
  }

  const shouldShowForm = (): boolean => {
    return !!org_id;
  }

  const shouldShowCaptcha = (): boolean => {
    return shouldShowForm() && isNotEmpty(first_name) && isNotEmpty(last_name) && isPhoneNumber(phone_number) && isEmail(email);
  }

  const shouldShowSubmit = (): boolean => {
    return shouldShowCaptcha() && isNotEmpty(captcha_response);
  }

  const submit = (): void => {
    if (org_id) {
      api.sendRequest(org_id, site_config!.domain, first_name, last_name, phone_number, email, captcha_response!);
    }
  }

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    submit();
    // handle form submission
  };

  return !store.requested ? (
    <>
      <GetStartedOrgs setter={setOrgId} />

      {!!org_id && (
        <Fader>
          <div style={{ paddingTop: 25 }}>
            <Row>
              <Col xs={2} sm={1}>
                <Bubble>2</Bubble>
              </Col>
              <Col xs={10} sm={11}>

                <h2>Fill in the Form</h2>

                <form style={{ marginTop: -1 }} onSubmit={handleSubmit}>
                  <Text name='first_name' title='Your First Name' value={first_name} setter={setFirstName} required />
                  <Text name='last_name' title='Your Last Name' value={last_name} setter={setLastName} required />
                  <Phone name='phone_number' title='Your Phone Number' value={phone_number} setter={setPhoneNumber} required />
                  <Email name='email' title='Your Email' value={email} setter={setEmail} required />

                  <Captcha show={shouldShowCaptcha()} verify={verifyCaptcha} />
                  <GetStartedSubmit show={shouldShowSubmit()} />
                </form>

              </Col>
            </Row>
          </div>
        </Fader>
      )}
    </>
  ) : null;
}

export default GetStartedForm;